module.exports = __webpack_public_path__ + "media/flags/001-austria-921b8591.svg";